import { atom } from "recoil";
import { GetMobilityLive } from "../types/types";

export type Accident = GetMobilityLive | null;

export const accidentState = atom<Accident>({
  key: "accidentState",
  default: null,
});
